<template>
  <DepartmentTripleCards
    :directions="data.directions || {}"
    :patient-needs="data.patientNeeds || {}"
    :documents="data.documents || {}"
  />
</template>

<script>
import DepartmentTripleCards from '@/components/Departments/DepartmentTripleCards.vue';

export default {
  name: 'AppDepartmentTripleCardsBlock',
  components: { DepartmentTripleCards },
  props: {
    data: { type: Object, default: () => ({}) },
  },
};
</script>
